import news20210718 from './2021-07-18.vue'
import news20251021 from './2025-10-21.vue'
import news20251027 from './2025-10-27.vue'

const list = [
  {
    id: 'news20210718',
    component: news20210718
  },
  {
    id: 'news20251021',
    component: news20251021
  },
  {
    id: 'news20251027',
    component: news20251027
  }
]

export const components = list.reduce((cur, item) => {
  cur[item.id] = item.component
  return cur
}, {})
